import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import "./JobPreferencesModal.css";

function JobPreferencesModal({ show, handleClose }) {
  const jobOptions = [
    { value: "React.Js Developer", label: "React.Js Developer" },
    { value: "Frontend Developer", label: "Frontend Developer" },
    { value: "React Native Developer", label: "React Native Developer" },
    { value: "UI Developer", label: "UI Developer" },
    { value: "Software Engineer", label: "Software Engineer" },
  ];

  const locationOptions = [
    { value: "Nagpur", label: "Nagpur" },
    { value: "Pune", label: "Pune" },
    { value: "Mumbai", label: "Mumbai" },
    { value: "Hyderabad", label: "Hyderabad" },
    { value: "Bangalore", label: "Bangalore" },
  ];

  const [jobs, setJobs] = useState([
    { value: "React.Js Developer", label: "React.Js Developer" },
  ]);

  const [locations, setLocations] = useState([
    { value: "Nagpur", label: "Nagpur" },
  ]);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "84px",
      borderRadius: "4px",
      border: "1px solid #d7dce5",
      boxShadow: "none",
      padding: "6px",
      alignItems: "flex-start",
    }),

    valueContainer: (provided) => ({
      ...provided,
      display: "flex",
      flexWrap: "wrap",
      gap: "8px",
      alignItems: "flex-start",
      padding: "0",
    }),

    multiValue: (provided) => ({
      ...provided,
      background: "#fff",
      border: "1px solid #6b6b6b",
      borderRadius: "20px",
      padding: "5px 8px",
    }),

    multiValueLabel: (provided) => ({
      ...provided,
      color: "#333",
      fontSize: "14px",
    }),

    multiValueRemove: (provided) => ({
      ...provided,
      cursor: "pointer",
      ":hover": {
        background: "transparent",
        color: "#000",
      },
    }),

    indicatorSeparator: () => ({
      display: "none",
    }),

    dropdownIndicator: () => ({
      display: "none",
    }),

    placeholder: (provided) => ({
      ...provided,
      color: "#9aa2b1",
      marginTop: "8px",
    }),
  };

  const handleSave = () => {
    console.log({
      preferredJobs: jobs,
      preferredLocations: locations,
    });

    handleClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
      dialogClassName="common-modal job-preference-modal"
    >
      <Modal.Header className="we-modal-header d-flex align-items-center">
        <Modal.Title className="we-modal-title">
          {" "}
          <Button
            variant="link"
            className="we-back-btn p-0 me-2"
            onClick={handleClose}
          >
            <FontAwesomeIcon icon={faAngleLeft} />
          </Button>{" "}
          Job preferences
        </Modal.Title>
        <button
          type="button"
          className="btn-close ms-auto"
          onClick={handleClose}
          aria-label="Close"
        ></button>
      </Modal.Header>

      <Modal.Body className="jp-modal-body">
        <Form>
          {/* Preferred Job Titles */}
          <Form.Group className="mb-4">
            <Form.Label className="jp-form-label">
              Preferred Job Title(s)
              <span className="text-danger">*</span>
            </Form.Label>

            <Select
              isMulti
              options={jobOptions}
              value={jobs}
              onChange={setJobs}
              styles={customStyles}
              placeholder="Enter or select your preferred job title"
            />
          </Form.Group>

          {/* Preferred Locations */}
          <Form.Group>
            <Form.Label className="jp-form-label">
              Preferred Location(s)
              <span className="text-danger">*</span>
            </Form.Label>

            <Select
              isMulti
              options={locationOptions}
              value={locations}
              onChange={setLocations}
              styles={customStyles}
              placeholder="Enter or select your preferred location"
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer className="jp-modal-footer">
        <Button className="jp-btn-save" onClick={handleSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default JobPreferencesModal;
